import React, { useState } from 'react';
import { Tabs } from 'antd';

import ListUsers from '../components/user/ListUsers';
import CreateUserForm from '../components/user/CreateUserForm';
import SingleUser from '../components/user/SingleUser';
import ModifyUserForm from '../components/user/ModifyUserForm';
import DeleteUserButton from '../components/user/DeleteUserButton';
import PermissionGroupManagement from '../components/user/PermissionGroupManagement';

const UserManagementPage = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedUserId, setSelectedUserId] = useState(null);



  const handleSelectUser = (id) => {
    setSelectedUserId(id);
    setCurrentView('viewUser');
  };

  return (
    <Tabs defaultActiveKey="users" items={[{ key: 'users', label: 'Utilisateurs', children: <div>
      {currentView === 'create' && <CreateUserForm onUserCreated={() => setCurrentView('list')} />}
      {currentView === 'modify' && selectedUserId && <ModifyUserForm userId={selectedUserId} onUserModified={() => setCurrentView('list')} />}
      {currentView === 'delete' && selectedUserId && <DeleteUserButton userId={selectedUserId} onUserDeleted={() => setCurrentView('list')} />}
      {currentView === 'list' && <ListUsers onSelectUser={handleSelectUser} />}
      {currentView === 'viewUser' && selectedUserId && (
        <SingleUser userId={selectedUserId} onChangeView={setCurrentView} />
      )}
    </div> }, { key: 'groups', label: 'Groupes de permissions', children: <PermissionGroupManagement /> }]} />
  );
};

export default UserManagementPage;
